import { differenceInYears, format } from 'date-fns';
import { AtLeastOneFieldValidationRule, DobValidationRule } from 'sharedComponents/inputGroup/InputInterface';

export const getUtcDate = (dateStr: string) => {
  const dateString = dateStr;
  // Parse the date string
  const date = new Date(dateString);
  const utcDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
  const newUtcDate = new Date(utcDate);
  // Get day, month, and year
  const day = newUtcDate.getUTCDay();
  const month = newUtcDate.getUTCMonth() + 1;
  const year = newUtcDate.getUTCFullYear();
  const selectedDate = newUtcDate.getUTCDate();
  return { day, month, year, selectedDate };
};

export const handleOptions = (options: any) => {
  const newOptions: any[] = [];
  options.map((option: any) => {
    newOptions.push({ label: option.choiceText, value: option.choiceId });
  }); //isCorrect: option.isCorrect
  return newOptions;
};

export const formRequiredRules = (reqMesg: string) => {
  return {
    required: {
      value: true,
      message: reqMesg,
    },
  };
};

export const formPatternRules = (regex: RegExp, reqMesg: string) => {
  return {
    pattern: {
      value: regex,
      message: reqMesg,
    },
  };
};

export const dobValidationRule = (reqMesg: string): DobValidationRule => {
  return {
    validate: (value: Date) => {
      try {
        const today = new Date();

        const age = differenceInYears(today, value);

        if (age < 16) {
          return reqMesg;
        }

        return true;
      } catch (error) {
        console.error('dobValidationRule catch = ', error?.message);
      }
    },
  };
};

export const atLeastOneFieldValidationRule = (fieldName: string, reqMesg: string): AtLeastOneFieldValidationRule => {
  return {
    validate: (value, allValues) => {
      try {
        // Check if at least one of the fields has a value
        const otherFieldValue = allValues[fieldName];
        if (!value && !otherFieldValue) {
          return reqMesg;
        }

        return true;
      } catch (error) {
        console.error('atLeastOneFieldValidationRule catch = ', error?.message);
      }
    },
  };
};

export const dataFormat = (date: Date, formatType: string) => {
  return format(new Date(date), formatType);
};
